import { housesDict } from "../HouseInfo";
import Property from "../../components/Property/Property";

function CondoTwoSix() {
  return (
    <div>
      {/* <Property {...housesDict["C002"]} /> */}
      <Property
        {...{
          housesDict: housesDict["C002"],
          propertyId: "65c26c0e3886dd758c1690fa",
        }}
      />
    </div>
  );
}

export default CondoTwoSix;
